<template>
  <li class="dropdown messages-menu">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="triggerInfiniteBool = true">
      <i class="fa fa-bullhorn"></i>
      <span class="label label-success" v-show="headerNotiAnnounceTotal > 0">{{ numberFormat(headerNotiAnnounceTotal) }}</span>
    </a>
    <ul class="dropdown-menu"> 
      <li class="noti-header">
        <template v-if="headerNotiAnnounceTotal > 0">
          {{ labels[nowLang]['new_message1'] }} {{ numberFormat(headerNotiAnnounceTotal) }} {{ labels[nowLang]['new_message2'] }}
        </template>
        <template v-else>
          {{ labels[nowLang]['no_message'] }}
        </template>
      </li>
      <li>
        <!-- inner menu: contains the actual data -->
        <ul class="announce-list">
          <li v-for="headerAnn in headerNotiAnnounceRows"><!-- start message -->
            <div class="pull-left announce-box">
              <div class="announce-icon-box">
                <i class="fa fa-bullhorn"></i>
              </div>
              <router-link :to="{ name: 'hres3fx' }">
                <div class="announce-topic-box clearfix">
                  <div class="announce-topic">
                  {{ headerAnn.subject }} 
                  </div>
                  <small><i class="fa fa-clock-o"></i> {{ setDateOutput(headerAnn.dteeffec) }}</small>
                  <div class="announce-detail">{{ headerAnn.remark }}</div>
                </div>
              </router-link>
            </div>
          </li>
          <hrms-infinite-loading v-if="triggerInfiniteBool" @infinite="onInfinite" ref="headerNotiAnnounceLoading" />
        </ul>
      </li>
      <li class="footer"><router-link :to="{ name: 'hres3fx' }">{{ labels[nowLang]['view_all'] }}</router-link></li>
    </ul>
  </li>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'header-message',
  props: [ 'headerNotiAnnounceTotal', 'headerNotiAnnounceInfiniteLoading', 'receivedHeaderNotiAnnounceInfiniteLoading', 'numberFormat', 'nowLang' ],
  data () {
    return {
      labels: {
        en: {
          'no_message': 'There are no new announcement.',
          'new_message1': 'There are',
          'new_message2': 'new announcements.',
          'view_all': 'View all announcements.'
        },
        th: {
          'no_message': 'คุณยังไม่มีข้อความใหม่',
          'new_message1': 'คุณมีข้อความใหม่',
          'new_message2': 'ข้อความ',
          'view_all': 'ดูข้อความทั้งหมด'
        }
      },
      headerNotiAnnounceRows: [],
      page: 1,
      limit: 10,
      triggerInfiniteBool: false
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    onInfinite ($state) {
      this.receivedHeaderNotiAnnounceInfiniteLoading(this.params($state))
      this.page++
    },
    params ($state) {
      return {
        searchParams: {
          p_page: this.page,
          p_limit: this.limit
        },
        $state: $state,
        triggerInfinite: this.triggerInfinite
      }
    },
    triggerInfinite ({ data, $state }) {
      if (data.rows.length) {
        this.headerNotiAnnounceRows = this.headerNotiAnnounceRows.concat(data.rows)
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// HeaderAnnounce.vue?707ebcd0